import { render, staticRenderFns } from "./TabelaFinanceiro.vue?vue&type=template&id=225b7a24&"
import script from "./TabelaFinanceiro.vue?vue&type=script&lang=js&"
export * from "./TabelaFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports